export const cryptoCategories = [
  {
    name: 'Established Projects',
    description: 'Major cryptocurrencies with proven track records',
    riskLevel: 'Low',
    warning: 'While established, still subject to market volatility'
  },
  {
    name: 'Emerging Projects',
    description: 'Promising new blockchain platforms',
    riskLevel: 'Moderate',
    warning: 'Higher risk due to developing technology and adoption'
  },
  {
    name: 'Meme Coins',
    description: 'Community-driven social tokens',
    riskLevel: 'Very High',
    warning: 'Extremely volatile! High risk of total loss'
  }
];